export enum ResponsibilityTypeCodesEnum {
  RSP_TYPE_I = 'RSP_TYPE_I',
  RSP_TYPE_II = 'RSP_TYPE_II',
  RSP_TYPE_III = 'RSP_TYPE_III',
  RSP_TYPE_IV = 'RSP_TYPE_IV',
  RSP_TYPE_V = 'RSP_TYPE_V',
  RSP_TYPE_VI = 'RSP_TYPE_VI',
}
